<template>
	<v-dialog :value="value" max-width="560" persistent @input="$emit('input', $event)">
		<v-card class="background-2 round-card vat-create-dialog">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3 mb-0">Nuovo codice IVA</p>
				<v-spacer></v-spacer>
				<v-btn icon @click="$emit('input', false)"><v-icon>close</v-icon></v-btn>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="pt-4">
				<p class="body-2 grey--text mb-4">
					Valori proposti dall'XML (IVA {{ label }}): controlla la tipologia prima di creare.
					Il codice resta modificabile in Impostazioni → Categorie IVA.
				</p>
				<v-row dense>
					<v-col cols="4">
						<v-text-field v-model="form.value" label="Codice*" outlined dense :error-messages="errors.value"></v-text-field>
					</v-col>
					<v-col cols="8">
						<v-text-field v-model="form.text" label="Descrizione*" outlined dense :error-messages="errors.text"></v-text-field>
					</v-col>
					<v-col cols="4">
						<v-text-field :value="form.vat" label="Aliquota %" outlined dense disabled></v-text-field>
					</v-col>
					<v-col cols="8">
						<v-text-field :value="form.natura || '—'" label="Natura" outlined dense disabled :error-messages="errors.natura"></v-text-field>
					</v-col>
					<v-col cols="6">
						<v-select v-model="form.type" :items="types" label="Tipologia*" outlined dense :error-messages="errors.type"></v-select>
					</v-col>
					<v-col cols="6">
						<v-text-field
							v-model="form.aswcodiva"
							label="AswCodIVA"
							hint="Codice Standard AssoSoftware, letto dall'XML quando presente"
							persistent-hint
							outlined
							dense
							:error-messages="errors.aswcodiva"
						></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-checkbox v-model="form.stamp" label="Applica bollo" hide-details dense class="mt-0"></v-checkbox>
					</v-col>
				</v-row>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="info" @click="$emit('input', false)">Annulla</v-btn>
				<v-btn text color="primary" :loading="saving" @click="create">Crea</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	/**
	 * Creazione del codice IVA mancante (aliquota/natura dell'XML senza codice
	 * in anagrafica), con i valori proposti dal backend. Serve sia all'import
	 * massivo sia al wizard del singolo documento; richiede il permesso
	 * Impostazioni del ruolo.
	 */
	export default {
		name: 'vat-code-dialog',
		props: {
			value: Boolean,
			proposal: Object,
			label: String,
			types: { type: Array, default: () => [] },
		},
		data() {
			return {
				form: {},
				errors: {},
				saving: false,
			}
		},
		watch: {
			value: {
				immediate: true,
				handler(open) {
					if(open) {
						this.form = Object.assign({}, this.proposal)
						this.errors = {}
						this.saving = false
					}
				},
			},
		},
		methods: {
			create() {
				this.saving = true
				this.errors = {}
				this.axios.post('import-edocuments-vats', this.form).then(response => {
					this.saving = false
					this.$emit('input', false)
					this.$store.commit('setSnackbar', {timeout: 6000, text: response.data.message, value: true, color: 'success'})
					this.$emit('created', response.data.vat)
				}, error => {
					this.saving = false
					const errors = error && error.response && error.response.data && error.response.data.errors
					this.errors = errors || {}
				})
			},
		},
	}
</script>
